import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Title from "../../components/common/Title";
import Layout from "../../components/layout/Layout";
import DatabaseAutoShutdown from "./components/DatabaseAutoShutdown";
import EventBridgeSchedules from "./components/EventBridgeSchedules";
import NatGateways from "./components/NatGateways";
import NigelScheduleTag from "./components/NigelScheduleTag";

/**
 * Admin dashboard page for managing cloud infrastructure components.
 *
 * @returns {JSX.Element} Admin interface with NAT gateways and database controls
 */
function Admin() {
  return (
    <Layout>
      {/* Main content */}
      <Grid container direction="column" wrap="nowrap" alignContent="center" justifyContent="center" pt={10}>
        {/* NAT Gateways */}
        <Box sx={{ pb: 5, px: { xs: 2, md: 10 } }}>
          <Title text="Available NAT Gateways" sx={{ mb: 5, mx: 2 }} />
          <NatGateways />
        </Box>

        {/* Database Auto-Shutdown */}
        <Box sx={{ pb: 5, px: { xs: 2, md: 10 } }}>
          <Title text="Database Auto-Shutdown" sx={{ mb: 5, mx: 2 }} />
          <DatabaseAutoShutdown />
        </Box>

        {/* Event Bridge Schedules */}
        <Box sx={{ pb: 5, px: { xs: 2, md: 10 } }}>
          <Title text="Event Bridge Schedules" sx={{ mb: 5, mx: 2 }} />
          <EventBridgeSchedules />
        </Box>

        {/* Nigel Schedule Tag */}
        <Box sx={{ pb: 5, px: { xs: 2, md: 10 } }}>
          <Title text="Nigel And Metabase Schedule Tag" sx={{ mb: 5, mx: 2 }} />
          <NigelScheduleTag />
        </Box>
      </Grid>
    </Layout>
  );
}

export default Admin;
